import { FC } from 'react';

import { VacancyFilter } from 'components/CampaignCreationWizard/VacancySelectStep/components/VacancyListTab/VacancyFiltersPanel/VacancyFilter/VacancyFilter';
import { VacancySearchField } from 'components/CampaignCreationWizard/VacancySelectStep/components/VacancyListTab/VacancyFiltersPanel/VacancySearchField/VacancySearchField';

import styles from 'components/CampaignCreationWizard/VacancySelectStep/components/VacancyListTab/VacancyFiltersPanel/VacancyFiltersPanel.module.less';

export const VacancyFiltersPanel: FC = () => (
    <div className={styles.wrapper}>
        <div className={styles.search}>
            <VacancySearchField />
        </div>
        <div className={styles.filtersWrapper}>
            <div className={styles.singleFilter}>
                <VacancyFilter filterKey="areas" />
            </div>
            <div className={styles.singleFilter}>
                <VacancyFilter filterKey="users" />
            </div>
        </div>
    </div>
);
